import { render, staticRenderFns } from "./tennis-league-management.vue?vue&type=template&id=218cc0f0"
import script from "./tennis-league-management.vue?vue&type=script&lang=ts"
export * from "./tennis-league-management.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports